import React, { SVGProps } from "react";
export default function SupUserAnon008(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 5.38045L10 0.760925L2 5.38045M18 5.38045L10 9.8763M18 5.38045V7.12561L16.3295 8.09739M10 19.239L18 14.4958V12.6348M10 19.239L2 14.4958V12.6348M10 19.239V17.4123M2 5.38045L10 9.8763M2 5.38045V7.12561L3.67054 8.09739M10 9.8763V11.7794M10 11.7794L3.67054 8.09739M10 11.7794L16.3295 8.09739M10 13.6614L18 8.90498M10 13.6614L2 8.90498M10 13.6614V15.5302M18 8.90498V10.7186L16.3295 11.6975M18 8.90498L16.3295 8.09739M2 8.90498V10.7186L3.67054 11.6975M2 8.90498L3.67054 8.09739M10 15.5302L3.67054 11.6975M10 15.5302L16.3295 11.6975M10 17.4123L18 12.6348M10 17.4123L2 12.6348M18 12.6348L16.3295 11.6975M2 12.6348L3.67054 11.6975"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
